<template>
  <vue-clip
      ref="vc"
      :options="options"
      :on-added-file="addedFile"
      :on-complete="completeFile"
      :on-sending="onSending"
      :on-removed-file="removedFile"
      class="custom-uploader"
      :class="{
        'custom-uploader--readonly': readonly && !innerFilePresent,
        'custom-uploader--word': theme,
        'custom-uploader--design-new': design === 'new'
      }"
  >
    <template slot="clip-uploader-body" v-if="innerFilePresent && !theme">
      <div class="custom-uploader__file">
        <div class="custom-uploader__body">
          <div v-if="file.file || file.status === 'success'" class="custom-uploader__part">
            <a
                v-if="!theme"
                :href="file.file || file.customAttributes.link"
                target="_blank"
                class="custom-uploader__filename"
            >
              <slot name="file-icon"><img src="@/assets/img/attach-file-icon.svg" alt=""></slot>
              View
<!--              {{ file.file_name || file.name }}-->
            </a>
          </div>
          <div class="custom-uploader__part custom-uploader__part--uploading">
            <span v-if="file.status !== 'error' && file.status !== 'success' && file.progress">Uploading</span>
            <div class="custom-uploader__right">
              <div v-if="file.status !== 'error' && file.status !== 'success' && file.progress" class="custom-uploader__progress">
                {{ Math.round(file.progress) }}%
              </div>
              <button
                  v-if="!readonly && !theme"
                  type="button"
                  class="custom-uploader__delete"
                  @click="removedFile"
              >
                <slot name="remove-icon"><img src="@/assets/img/delete-uploader-icon.svg" alt=""></slot>
              </button>
            </div>
          </div>
        </div>
        <div
            class="custom-uploader__line"
            v-if="file.status !== 'error' && file.status !== 'success' && file.progress"
        >
          <span class="custom-uploader__indicator" :style="{ width: file.progress + '%' }"></span>
        </div>
      </div>
      <div v-if="file.status === 'error'" class="custom-uploader__error">{{ message }}</div>
    </template>
    <template slot="clip-uploader-action">
      <slot name="action" :file-present="innerFilePresent">
      <div>
        <button
          v-if="!innerFilePresent && theme"
          :id="inputId"
          type="button"
          class="custom-uploader__word dz-message"
        >
          {{ lineText }}
        </button>
        <component
          :is="design === 'new' ? 'button' : 'div'"
          v-if="!innerFilePresent && !theme"
          :id="inputId"
          :type="design === 'new' ? 'button' : null"
          class="custom-uploader__message dz-message"
        >
          <img src="@/assets/img/file/attach-file-icon.svg" alt=""/>
          <span>Attach the file</span>
        </component>
      </div>
      </slot>
    </template>
  </vue-clip>
</template>

<script>
import { getAccessToken } from 'axios-jwt'

export default {
  name: 'AppUploader',
  props: {
    file_prop: Object,
    singleFile: { type: Boolean, default: false },
    extensions: {
      type: Array,
      default: () => ['image/*', 'application/pdf']
    },
    readonly: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: `${process.env.VUE_APP_API_URL}files/`
    },
    theme: {
      type: String,
      default: ''
    },
    formDataFormats: {
      type: String,
      default: 'JPEG,BMP,PNG,TIFF,PDF'
    },
    lineText: {
      type: String,
      default: 'Upload'
    },
    inputId: String,
    design: {
      type: String,
      default: 'legacy',
      validator: value => ['legacy', 'new'].includes(value)
    }
  },
  model: {
    prop: 'file_prop',
    event: 'onAddedFile'
  },
  data() {
    return {
      options: {
        url: this.$props.url,
        maxFiles: {
          limit: this.singleFile ? 1 : 100,
          message: 'You cannot upload more than 1 file'
        },
        acceptedFiles: {
          extensions: this.$props.extensions,
          message: 'Wrong file format'
        },
        maxFilesize: {
          limit: 15,
          message: 'File size exceeds allowed'
        },
        uploadMultiple: false
      },
      message: '',
      progress: 0,
      file: {}
    }
  },
  computed: {
    innerFilePresent() {
      return Object.keys(this.file).length !== 0
    }
  },
  mounted() {
    // if (this.outerFilePresent) {
    //   this.file = this.$props.file_prop
    // }
  },
  watch: {
    file_prop: {
      handler(value) {
        if (value) this.file = value
        else if (this.design === 'new') this.file = {}
      },
      immediate: true
    }
  },
  methods: {
    addedFile(file) {
      if (this.singleFile && this.innerFilePresent) return
      this.file = file
      this.$emit('uploading', true)
    },
    onSending(file, xhr, formData) {
      xhr.setRequestHeader('Authorization', `Bearer ${getAccessToken()}`)
      formData.append('size', 15)
      formData.append('formats', this.formDataFormats)
    },
    completeFile(file, status, xhr) {
      if (this.singleFile && file !== this.file) return
      this.$emit('uploading', false)
      if (file.status === 'error') {
        this.message = file.errorMessage
        this.removedFile()
        this.$emit('upload-error', this.message || 'Could not upload the file. Please try again.')
        return false
      }
      let response = null
      try {
        response = JSON.parse(xhr.responseText)
        if (this.singleFile && (!response.id || !response.file)) throw new Error('Invalid file response')
      } catch (error) {
        this.removedFile()
        this.$emit('upload-error', 'Could not upload the file. Please try again.')
        return false
      }
      file.addAttribute('link', response.file)
      this.$emit('onAddedFile', response)
      this.message = ''
    },
    removedFile() {
      this.$emit('uploading', false)
      this.$refs.vc.files = []
      this.file = {}
      this.$emit('onAddedFile', {})
    },
  }
}
</script>

<style lang="sass">
.custom-uploader[readonly]
  .custom-uploader__action
    display: none

  .custom-uploader__delete
    display: none

.custom-uploader--flex
  display: flex

  .custom-uploader__file
    width: 100%

.custom-uploader--min-150
  min-width: 150px

.custom-uploader--multi
  display: flex
  flex-direction: column

  .custom-uploader__action
    order: 1

  .custom-uploader__body
    margin-bottom: 10px

  .custom-uploader__message
    display: flex

.custom-uploader__right
  display: flex
  align-content: center
  gap: 15px

.custom-uploader__message
  display: inline-flex
  align-items: center
  gap: 8px
  padding: 11px 18px 11px 12px
  border: 0
  border-radius: 20px
  background-color: $color-theme
  cursor: pointer
  font: inherit

  span
    color: #fff
    font-size: 13px
    font-weight: 600

.custom-uploader__body
  display: flex
  align-items: center
  min-width: 80px

.custom-uploader__line
  width: 100%
  height: 6px
  margin-top: 10px
  background-color: #ebebeb
  border-radius: 50px

.custom-uploader__indicator
  display: block
  width: 0
  height: 100%
  background-color: $color-theme
  border-radius: 50px
  transition: width 0.5s

.custom-uploader__part
  display: flex
  align-items: center

  &:first-child
    flex-grow: 1

  &:last-child
    flex-shrink: 0

.custom-uploader__part--uploading
  justify-content: space-between

  span
    color: #181818
    font-size: 13px
    font-weight: 500

.custom-uploader__img
  flex-shrink: 0
  width: 120px
  height: 120px
  margin-right: 15px

  img
    width: 100%
    height: 100%
    object-fit: cover

.custom-uploader__filename
  display: flex
  align-items: center
  gap: 10px
  height: 38px
  color: #5f5f5f
  font-size: 14px
  text-decoration: none
  word-break: break-word

.custom-uploader__progress
  color: #9b9b9b
  font-size: 14px
  font-weight: 600

.custom-uploader__error
  order: 2
  margin-top: 5px
  font-size: 14px
  color: $color-error

.custom-uploader__delete
  img
    width: 10px
    height: 10px

.custom-uploader__drop
  display: flex
  align-items: center
  flex-direction: column
  width: 100%
  padding: 30px 20px
  border: 2px dashed #6ab3ef
  border-radius: 5px
  text-align: center
  transition: border-color 0.3s, background-color 0.3s

  &:hover
    border-color: #49b1f5
    background-color: #f1f8fe

    p span
      text-decoration: underline

  p
    margin-bottom: 5px
    font-size: 16px
    color: $color-text-base

    span
      color: $color-theme
      font-size: 16px

  small
    color: #7c8db0
    font-size: 14px

.custom-uploader__extensions
  order: 3
  margin-top: 5px
  color: #7c8db0
  font-size: 14px

.custom-uploader__icon
  display: flex
  align-items: center
  margin-bottom: 5px

  span
    font-size: 16px

.custom-uploader--readonly
  pointer-events: none

  .custom-uploader__message
    border: 1px solid #ff9416

.custom-uploader--word
  .custom-uploader__line
    margin-top: 6px

.custom-uploader__word
  color: $color-theme
  font-size: 14px
  font-weight: 500

.custom-uploader--design-new
  color: $ui-text
  font-family: $ui-font-body

  .custom-uploader__message
    min-height: $ui-control-height
    padding: 0 $ui-space-16
    border: 1px solid $ui-blue
    border-radius: $ui-control-radius
    background-color: $ui-blue

    &:hover
      border-color: $ui-blue-hover
      background-color: $ui-blue-hover

    &:focus-visible
      outline: 3px solid rgba($ui-blue, .18)
      outline-offset: 2px

    span
      font-family: $ui-font-body
      font-size: $ui-font-size-control
      font-weight: 500

  .custom-uploader__file
    width: 100%
    padding: 0 $ui-space-12
    border: 1px solid $ui-line-strong
    border-radius: $ui-control-radius
    background-color: $ui-surface-soft

  .custom-uploader__body
    min-height: $ui-control-height

  .custom-uploader__filename
    color: $ui-blue
    font-family: $ui-font-body
    font-size: $ui-font-size-body

  .custom-uploader__delete
    display: inline-flex
    width: $ui-control-height-compact
    height: $ui-control-height-compact
    align-items: center
    justify-content: center
    border-radius: $ui-control-radius

    &:focus-visible
      outline: 3px solid rgba($ui-blue, .18)
      outline-offset: 2px

  .custom-uploader__line
    height: $ui-space-4
    margin-top: 0
    background-color: $ui-line

  .custom-uploader__indicator
    background-color: $ui-blue

  .custom-uploader__error
    color: $ui-red

  &.custom-uploader--readonly
    opacity: .72

    .custom-uploader__message
      border-color: $ui-line-strong
      background-color: $ui-surface-soft

      span
        color: $ui-muted
</style>
